import { Injectable } from "@angular/core";

import { ApiTemplate } from "../base/template/api.template";
import { Application, ApplicationRequest } from "./model/application.model";

@Injectable({ providedIn: 'root' })
export class ApplicationApi extends ApiTemplate<Application, ApplicationRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/applications");
    }
}
